import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/lib/motion";
import { PORTFOLIO } from "@/data/content";

export default function Portfolio() {
  return (
    <section id="portfolio" className="py-24 lg:py-32 bg-white scroll-mt-20" data-testid="portfolio-section">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <span className="overline text-[var(--dm-purple)]">Our Work</span>
          <h2 className="font-head font-extrabold tracking-tighter text-4xl sm:text-5xl text-slate-900 mt-4 leading-[1.05]">
            Real campaigns. <span className="text-gradient">Real numbers.</span>
          </h2>
          <p className="mt-5 text-lg text-slate-600">A look at the measurable growth we&apos;ve delivered for brands like yours.</p>
        </Reveal>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          {PORTFOLIO.map((p, i) => (
            <motion.article
              key={p.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.65, delay: (i % 2) * 0.1 }}
              className="group rounded-[1.75rem] border border-slate-200 overflow-hidden bg-white hover:shadow-2xl hover:shadow-slate-200 transition-shadow duration-300"
              data-testid={`portfolio-card-${i}`}
            >
              <div className="relative h-56 overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                <div className="absolute inset-0" style={{ background: "linear-gradient(180deg, transparent 40%, rgba(15,23,42,0.55))" }} />
                <span className="absolute top-4 left-4 rounded-full bg-white/90 backdrop-blur px-3 py-1 text-xs font-head font-bold text-slate-800">{p.tag}</span>
                <div className="absolute bottom-4 left-4 right-4 flex items-end justify-between">
                  <h3 className="font-head font-bold text-white text-xl max-w-[70%]">{p.title}</h3>
                  <span className="w-10 h-10 rounded-full bg-white grid place-items-center text-slate-900 group-hover:bg-[var(--dm-orange)] group-hover:text-white transition-colors duration-300">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
              </div>
              <div className="p-6 flex items-center justify-between">
                <div className="flex items-center gap-6">
                  <div>
                    <div className="text-xs text-slate-400 uppercase tracking-wider mb-1">Before</div>
                    <div className="font-head font-bold text-slate-500 text-lg line-through decoration-slate-300">{p.before}</div>
                  </div>
                  <div>
                    <div className="text-xs text-slate-400 uppercase tracking-wider mb-1">After</div>
                    <div className="font-head font-bold text-slate-900 text-lg">{p.after}</div>
                  </div>
                </div>
                <div className="text-right">
                  <div className="font-head font-extrabold text-2xl text-gradient">{p.metric}</div>
                  <div className="text-xs text-slate-500">{p.metricLabel} · {p.period}</div>
                </div>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
